const serviceNameCollator = new Intl.Collator("en", { sensitivity: "base" });

const getYear = (service) => {
    const value = service?.serviceYear ?? service?.year;
    const year = Number(value);
    return value != null && String(value).trim() !== "" && Number.isFinite(year)
        ? year
        : Number.NEGATIVE_INFINITY;
};

const getName = (service) =>
    String(service?.serviceName ?? "").trim().replace(/\s+/g, " ");

// Keep the default client-service order independent of due dates and API order.
export const sortClientServices = (services) => {
    if (!Array.isArray(services)) return [];

    return [...services].sort((left, right) => {
        const leftYear = getYear(left);
        const rightYear = getYear(right);
        if (leftYear !== rightYear) return leftYear > rightYear ? -1 : 1;

        const leftName = getName(left);
        const rightName = getName(right);
        if (!leftName && rightName) return 1;
        if (leftName && !rightName) return -1;

        // Array.sort is stable: equivalent names retain their incoming order.
        return serviceNameCollator.compare(leftName, rightName);
    });
};
